import React from "react";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
//Import Breadcrumb

const LoadingDialog = ({ open }) => {
    return (
        <React.Fragment>
            <Dialog
                open={open}
                PaperProps={{ sx: { padding: 1 } }}
            >
                <DialogContent style={{color: '#C81E5D'}}>
                    <CircularProgress color="inherit"/>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default LoadingDialog;
